import * as RadixTooltip from "@radix-ui/react-tooltip";
import { HelpCircle } from "lucide-react";
import type { ReactNode } from "react";

export const TooltipProvider = ({ children }: { children: ReactNode }) => (
	<RadixTooltip.Provider delayDuration={200}>{children}</RadixTooltip.Provider>
);

interface HintProps {
	children: ReactNode;
	label?: string;
}

export const Hint = ({ children, label = "More information" }: HintProps) => (
	<RadixTooltip.Root>
		<RadixTooltip.Trigger asChild>
			<button
				type="button"
				aria-label={label}
				className="inline-flex items-center text-ink-faint transition-colors hover:text-ink"
			>
				<HelpCircle className="h-3.5 w-3.5" strokeWidth={1.75} />
			</button>
		</RadixTooltip.Trigger>
		<RadixTooltip.Portal>
			<RadixTooltip.Content
				sideOffset={6}
				collisionPadding={12}
				className="z-50 max-w-xs rounded-md border border-line bg-surface px-3 py-2 text-xs leading-relaxed text-ink-muted shadow-lg"
			>
				{children}
				<RadixTooltip.Arrow className="fill-[var(--color-line)]" />
			</RadixTooltip.Content>
		</RadixTooltip.Portal>
	</RadixTooltip.Root>
);

export const LabelWithHint = ({ label, children }: { label: string; children: ReactNode }) => (
	<span className="flex items-center gap-1.5">
		<span className="text-sm text-ink">{label}</span>
		<Hint label={`About ${label}`}>{children}</Hint>
	</span>
);
